import {
  NativeStackNavigationProp,
  createNativeStackNavigator,
} from "@react-navigation/native-stack";

import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import { UserLoggedInNavigatorParamList } from "../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";

import { DayFilter } from "../../TeamScheduleAdmin/filter";

export type RoutineScheduleDaily = {
  freq: "daily";
  isAllDay: boolean;
  deadlineDuration: number | null;
  weekdays: {
    weekday: number;
    startTime: {
      hour: number;
      minute: number;
    } | null;
    originalTaskImportance: Record<string, "REQUIRED" | "OPTIONAL">;
    taskImportanceChanges: Record<string, "REQUIRED" | "OPTIONAL" | null>;
  }[];
};

export type RoutineScheduleWeekly = {
  freq: "weekly";
  startWeekday: number;
  endWeekday: number;
  weeks: number[];
};

export type RoutineScheduleMonthly = {
  freq: "monthly";
  months: number[];
  startDay: number;
  endDay: number;
};

export type RoutineSchedule =
  | RoutineScheduleDaily
  | RoutineScheduleWeekly
  | RoutineScheduleMonthly;

export type ControlType = "none" | "check" | "checklist";

export type RoutineEditParams = {
  id: string;
  mode?: "CREATE";
  orgWorkspaceId?: string;
  createFreq?: "daily" | "weekly" | "monthly";
  createDailyDaysFilter?: DayFilter;
  createDailyStartTimeHour?: number;
  createDailyStartTimeMinute?: number;
  createRoleId?: string;
};

type ScreenParams = {
  RoutineEditMain: RoutineEditParams;
  RoutineEditOwnerTeam: undefined;
  RoutineEditScheduleDailyTaskImportance: {
    id: string;
  };
  RoutineEditChecklist: {
    routineId: string;
    orgWorkspaceId?: string;
  };

  RoutineEditChecklistOrderSections: undefined;
  RoutineEditChecklistSectionOrderTasks: {
    sectionId: string;
  };
  RoutineEditChecklistSectionAddExistingTasks: {
    sectionId: string;
  };
  RoutineEditChecklistSectionIssueTeam: {
    sectionId: string;
  };
  RoutineEditChecklistTask: {
    taskId: string;
    routineId?: string;
    orgWorkspaceId?: string;
  };
  RoutineEditFileSelect: undefined;
  RoutineEditAllFiles: undefined;
  WorkspaceRoutineEditFileSelect: {
    orgWorkspaceId: string;
  };
  WorkspaceRoutineEditSectionSettings: {
    orgWorkspaceId: string;
    sectionId: string;
  };
};

export const RoutineEditNavigator = createNativeStackNavigator<ScreenParams>();

type RoutineEditNavigationProp<T extends keyof ScreenParams> =
  CompositeNavigationProp<
    NativeStackNavigationProp<ScreenParams, T>,
    NativeStackNavigationProp<UserLoggedInNavigatorParamList, "RoutineEdit">
  >;
export type RoutineEditScreenProps<T extends keyof ScreenParams> = {
  navigation: RoutineEditNavigationProp<T>;
  route: RouteProp<ScreenParams, T>;
};
